import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=18710f0f&"
import script from "./Homepage.vue?vue&type=script&lang=js&"
export * from "./Homepage.vue?vue&type=script&lang=js&"
import style0 from "./Homepage.vue?vue&type=style&index=0&id=18710f0f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports